// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"7223dd83","544":"e39ad9a0","592":"973a88b4","752":"2b9b38c7","832":"eb3dd6e7","848":"8c29d66d","932":"0ea4ea13"}[chunkId] + ".chunk.js";
};